import { useEffect } from 'react'
import { useParams } from 'react-router'
import PageMeta from '../../../components/common/PageMeta'
import { useProfessional } from '../../../context/ProfessionalContext'
import ProfessionalResume from './ProfessionalResume'
import { ProfessionalTabs } from './Tabs/ProfessionalTabs'

const ProfessionalDetailPage = () => {
    const { id } = useParams<{ id: string }>()
    const { getProfessional } = useProfessional()

    useEffect(() => {
        if (!id) return
        getProfessional(id)
    }, [id])

    return (
        <>
            <PageMeta title='Empresa | CRM' description='Dados da empresa' />
            <div className='space-y-4'>
                <ProfessionalResume />
                <ProfessionalTabs />
            </div>
        </>
    )
}

export default ProfessionalDetailPage
